import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import { RPERolActividadesService } from '../rpe-rol-actividades/rpe-rol-actividades.service';
import {
  entityRPERolActividadesAddFailure,
  entityRPERolActividadesAddRequest,
  entityRPERolActividadesAddSuccess
} from './entity-rpe-rol-actividades.actions';


@Injectable()
export class RPERolActividadesEffects {
  // add
  addRequestRPERolActividades = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRPERolActividadesAddRequest),
      switchMap((action) =>
        this.rpeRolActividadesService.addRPERolActividades(action.item).pipe(
          map((item) => entityRPERolActividadesAddSuccess({ item })),
          catchError((error) =>
            of(entityRPERolActividadesAddFailure({ error }))
          )
        )
      )
    )
  );

  addSuccessRPERolActividades = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityRPERolActividadesAddSuccess),
        tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private rpeRolActividadesService: RPERolActividadesService,
    private router: Router
  ) {
    this.rpeRolActividadesService.url = environment.apiUrl;
  }
}
